
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.78018 11.16L8.36018 12.58C7.68018 11.89 7.02018 11 6.57018 9.64L8.51019 9.15C8.83019 10.04 9.28018 10.65 9.78018 11.16ZM10.1502 5.15L7.35018 2.35C7.15018 2.15 6.84018 2.15 6.64018 2.35L3.85018 5.15C3.54018 5.46 3.76018 6 4.21018 6H6.02018C6.04018 6.81 6.10018 7.54 6.21018 8.17L8.15018 7.68C8.08018 7.2 8.03019 6.63 8.02019 6H9.80019C10.2402 6 10.4602 5.46 10.1502 5.15ZM20.1502 5.15L17.3602 2.36C17.1602 2.16 16.8502 2.16 16.6502 2.36L13.8602 5.15C13.5402 5.46 13.7602 6 14.2102 6H15.9902C15.8902 9.68 14.7102 10.75 13.4502 11.88C12.9502 12.32 12.4402 12.8 12.0002 13.43C11.6602 12.94 11.2702 12.55 10.8702 12.19L9.46019 13.6C10.3902 14.45 11.0002 15.14 11.0002 17V21C11.0002 21.55 11.4502 22 12.0002 22C12.5502 22 13.0002 21.55 13.0002 21V17C13.0002 14.98 13.7102 14.34 14.7902 13.37C16.1702 12.13 17.8702 10.59 17.9902 6H19.7902C20.2402 6 20.4602 5.46 20.1502 5.15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-alt-route`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAltRoute

    ```js
    <b-new-b-icon-alt-route />
    ```
</docs>


